import React, { memo, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import copyIcon from './assets/Copy.svg';
import toastNotify from '../../../utils/toastNotify';

const StyledContainer = styled.div`
  position: relative;
  width: 100%;
`;

const StyledInput = styled.input`
  width: 100%;
  height: 38px;
  border-radius: 4px;
  border: solid 1px rgba(199, 186, 241, 0.2);
  background-color: rgba(34, 9, 108, 0.2);
  color: #c7baf1;
  padding: 5px 0 5px 10px;
  &:focus {
    outline: none;
  }
`;

const StyledButton = styled.button`
  width: 50px;
  height: 30px;
  border-radius: 4px;
  background-color: #08a57f;
  padding: 7px 0 7px 0;
  cursor: copy;
  position: absolute;
  right: 4px;
  top: 4px;
  img {
    width: 15px;
  }
`;

const CopyClip = ({ link }) => {
  const input = useRef(null);
  const onClickHandler = () => {
    input.current.select();
    document.execCommand('copy');
    toastNotify('Copied to Clipboard', 2000);
  };

  return (
    <StyledContainer>
      <StyledInput className="small" value={link} readOnly ref={input} />
      <StyledButton onClick={onClickHandler}>
        <img src={copyIcon} alt="Copy" />
      </StyledButton>
    </StyledContainer>
  );
};

CopyClip.propTypes = {
  link: PropTypes.string.isRequired,
};

export default memo(CopyClip);
